import { Blocks } from '@@/shared-components/content/blocks'
import {
  ADVANCED_BLOCKS,
  BLOCKS,
  CHILD_COMPONENTS,
  ICONS,
  LABELS,
  OVERWRITES,
  STYLES,
} from '~~/shared-project-components/content'

// Registers the project's custom content blocks (shared-project-components/content) onto the Blocks
// singleton so the web client can render and edit them. The admin editor module does the equivalent
// on its side. Must run after the `content` plugin (added by the layouts module).
export default defineNuxtPlugin({
  name: 'content-blocks',
  setup: () => {
    const instance = Blocks.getInstance()
    // Singletons persist across dev SSR requests; guard so addBlocks isn't called twice.
    if (!instance.getComponents()['feature-grid']) {
      instance.addBlocks(BLOCKS())
    }
    instance.setChildComponents(CHILD_COMPONENTS()) // hero = restyled slider general-slide
    // Restyle built-in block views (e.g. faq → MD Club design).
    Object.entries(OVERWRITES()).forEach(([key, view]) => {
      if (instance.getComponents()[key]) instance.overwriteBlock(key, 'view', view)
    })
    instance.addLabels(LABELS())
    instance.addIcons(ICONS())
    instance.setAdvancedBlocks(ADVANCED_BLOCKS())
    instance.addBlocksStyles(STYLES())
  },
})
